import { getDealSuccess } from "src/store/actions/deal";
import { pollingSuccess } from "src/store/actions/poller";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { TradeIn } from "Types/TradeIn";
import { deleteTradeInSuccess, patchTradeInSuccess } from "../actions/tradeIn";

const initialState: TradeIn = {};

const tradeInReducer = (
    state = initialState,
    action:
        | ActionType<typeof getDealSuccess>
        | ActionType<typeof pollingSuccess>
        | ActionType<typeof patchTradeInSuccess>
        | ActionType<typeof deleteTradeInSuccess>
) => {
    switch (action.type) {
        case getDealSuccess.type:
        case pollingSuccess.type:
            return { ...state, ...action.payload.deal.tradein };
        case patchTradeInSuccess.type:
            return {
                ...state,
                ...action.payload.tradeIn,
            };
        case deleteTradeInSuccess.type:
            return { ...initialState };
        default:
            return state;
    }
};

export default tradeInReducer;
